import React from "react";
import SurveyTable from "./SurveyTable";

function Survey() {
  return (
    <>
      <div className="container container-xxl">
        <div className="pagetitle d-flex justify-content-between">
          <h1>Eyeconx Surveys Admin Only</h1>
        </div>
        <div className="card">
          <div className="card-body p-2">
            <SurveyTable />
          </div>
        </div>
      </div>
    </>
  );
}

export default Survey;
